<app-page-header avatarHeader="true" [svg]="'v2:fi-br-triangle-warning'">
    {{ pageTitle }}
    <a mat-icon-button disableRipple
       [attr.aria-label]="routerBackButton.ariaLabel"
       [routerLink]="routerBackButton.route"
       [queryParams]="routerBackButton.queryParams">
        <mat-icon>arrow_back</mat-icon>
    </a>
</app-page-header>

<app-details-card-container [actionLines]="lines"
                            [showActions]="true"
                            [actions]="actions"
                            [loadingSubject$]="loadingSubject$"
                            (actionClicked)="$event.callback()">
    <mat-card>
        <mat-card-title>{{ 'Submitter Information' }}</mat-card-title>

        <mat-divider></mat-divider>

        <mat-card-content>
            <mat-list [loadingList]="!violation" combineLines>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Community' }}</span>
                    <span matListItemLine>{{ violation?.organization?.name }}</span>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Unit Address' }}</span>
                    <span [innerHTML]="violation?.unit?.address | addressLine" matListItemLine></span>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Owners' }}</span>
                    <span matListItemLine>{{ violation?.unit?.ownersOneLine }}</span>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-title>{{ 'Violation Details' + (violation?.pastDue ? ' &ndash; ' + violation.pastDue : '') }}</mat-card-title>

        <mat-divider></mat-divider>

        <mat-card-content>
            <mat-list [loadingList]="!violation" combineLines>
                <mat-list-item statusChipLine>
                    <span matListItemTitle>{{ 'Status' }}</span>
                    <app-status-chip [loadingInitialData]="loadingInitialData"
                                     [statusId]="violationStatus?.id"
                                     [label]="'Violation status'"
                                     [statuses]="violationStatuses"
                                     (statusSelected)="openStatusChange()"
                                     matListItemLine>
                    </app-status-chip>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Reported Date' }}</span>
                    <span matListItemLine>{{ violation?.reportedAt | legfiDate:'MM/DD/YYYY' }}</span>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Reported By' }}</span>
                    <span matListItemLine>{{ violation?.user?.memberships[0]?.name }}</span>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Resolve By Date' }}</span>
                    <span matListItemLine>{{ violation?.resolutionTime | legfiDate:'MM/DD/YYYY' }}</span>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Tags' }}</span>
                    <span matListItemLine>{{ violation?.tagsOneLine }}</span>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-title>{{ 'Violation Description' }}</mat-card-title>

        <mat-divider></mat-divider>

        <mat-card-content>
            <mat-list [loadingList]="!violation" [loadingLines]="3">
                <mat-list-item class="violation-header" [innerHTML]="violation?.header"></mat-list-item>
                <mat-list-item class="violation-message" [innerHTML]="violation?.message"></mat-list-item>
                <mat-list-item class="violation-footer" [innerHTML]="violation?.footer"></mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>

    <app-attachments-card [modelType]="modelType" [model]="violation"></app-attachments-card>

    <mat-card tableContent>
        <mat-card-title>{{ 'History' }}</mat-card-title>

        <mat-divider></mat-divider>

        <mat-card-content>
            <app-violation-history-table [violation]="violation" [statuses]="violationStatuses">
            </app-violation-history-table>
        </mat-card-content>

        <mat-divider></mat-divider>
    </mat-card>

    <app-comments-card [modelType]="modelType"
                       [model]="violation"
                       (commentsUpdated)="historyTable.refreshHistory()">
    </app-comments-card>

    <app-notes-card [modelType]="modelType" [model]="violation"></app-notes-card>
</app-details-card-container>
